export default __webpack_public_path__ + "static/media/KODAI.4b63cb35.png";